export default __webpack_public_path__ + "static/media/cost.d35ce2dc.svg";